'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useParams } from 'next/navigation'

type CardProps = {
    data: IFederation | ICompetition
    dataType: 'competition' | 'federation'
}

const StandardCard = ({ data, dataType }: CardProps) => {
    const params = useParams()
    const langParam = params?.lang
    const lang = Array.isArray(langParam) ? langParam[0] : (langParam as string) || 'en'

    // Determine the href based on dataType
    const href =
        dataType === 'competition'
            ? `/${lang}/competition/${data.id}/table`
            : `/${lang}/federation/${data.id}/competitions`

    return (
        <Link
            href={href}
            className='flex flex-col overflow-hidden rounded-lg border border-border bg-background shadow-sm transition-shadow hover:shadow-md'
        >
            <div className='relative h-40 w-full overflow-hidden bg-muted p-3'>
                {data?.logo ? (
                    <Image src={data.logo} alt={data.name || 'card image'} fill className='object-contain p-3' sizes="(max-width: 768px) 100vw, 33vw" />
                ) : (
                    <div className='flex h-full w-full items-center justify-center bg-muted text-3xl font-bold text-muted-foreground'>
                        {data?.name?.charAt(0).toUpperCase()}
                    </div>
                )}
            </div>
            <div className='flex flex-1 flex-col gap-2 p-4'>
                <p className='truncate text-sm font-semibold md:text-base'>{data?.name || 'Untitled item'}</p>
            </div>
        </Link>
    )
}

export default StandardCard
